/* «Comprar ahora» con casilla de condiciones (oct-2026).
   Añade la variante y la cantidad del formulario de la ficha al carrito y va directo al pago.
   No se usa el enlace /cart/<variante>:<cantidad> porque SUSTITUYE el carrito: probado el 6-oct,
   quien ya tenía productos dentro los perdía. Desde el 6-oct paga APARTE: crea un carrito solo con este producto
   (Storefront API, cartCreate) y va a su pago; el carrito del cliente no se toca. Plan B si falla: añadir al
   carrito y pagar con todo, como antes. */
if (!customElements.get('bw-buy-now')) {
  class BwBuyNow extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.error = this.querySelector('.bw-buy-now__error');
      this.button = this.querySelector('.bw-buy-now__btn');
      this.button.addEventListener('click', () => this.buy());
      // Sin casilla = cliente con pedidos anteriores, que ya aceptó las condiciones.
      if (this.checkbox) {
        this.checkbox.addEventListener('change', () => {
          if (this.checkbox.checked) this.error.hidden = true;
        });
      }
    }

    async buy() {
      if (this.checkbox && !this.checkbox.checked) {
        this.showError(window.theme?.strings?.cartTermsConfirmation);
        this.checkbox.focus();
        return;
      }
      if (!this.form || this.busy) return;
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const qtyInput = document.querySelector(`[name="quantity"][form="${this.form.id}"]`) || this.form.querySelector('[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      if (!variantId) return;
      const root = window.Shopify?.routes?.root || '/';
      this.busy = true;
      this.button.setAttribute('aria-disabled', 'true');
      try {
        // Carrito aparte; si falla (sin clave, API caída o sin stock), se sigue con el plan B de abajo.
        const url = await this.separateCheckout(root, variantId, qty).catch(() => null);
        if (url) {
          window.location.href = url;
          return;
        }
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'No se ha podido añadir el producto.');
        }
        window.location.href = `${root}checkout`;
      } catch (e) {
        this.showError(e.message);
        this.busy = false;
        this.button.removeAttribute('aria-disabled');
      }
    }

    async separateCheckout(root, variantId, qty) {
      const token = this.dataset.sfToken;
      if (!token) return null;
      const res = await fetch(`${root}api/2025-07/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({
          // El atributo «Origen» queda en el pedido (Información adicional): el carrito aparte sale a nombre de la app
          // de scripts, no de la tienda online, y así se sabe qué botón lo hizo.
          query: 'mutation($l:[CartLineInput!],$a:[AttributeInput!]){cartCreate(input:{lines:$l,attributes:$a}){cart{checkoutUrl totalQuantity}}}',
          variables: {
            l: [{ merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity: qty }],
            a: [{ key: 'Origen', value: 'Online web · Comprar ahora' }],
          },
        }),
      });
      const cart = (await res.json())?.data?.cartCreate?.cart;
      // Solo si entra la cantidad pedida entera; si no, el plan B da el error de stock de Shopify.
      return cart && cart.checkoutUrl && cart.totalQuantity === qty ? cart.checkoutUrl : null;
    }

    showError(text) {
      if (text) this.error.textContent = text;
      this.error.hidden = false;
    }
  }
  customElements.define('bw-buy-now', BwBuyNow);
}
